import {
  ChangeEvent, ReactElement, useEffect, useRef, useState,
} from 'react';
import { Image } from 'antd';
import { FaFileUpload, FaRegTrashAlt } from 'react-icons/fa';
import {
  DeleteButton, PictureBox, PictureButton, PictureInputContainer,
} from './styles';
import { getContainerModal } from 'helpers/modalImage';
import { useFormContext } from 'react-hook-form';
import { EditClientFormValues } from '../Form/types';

interface PictureInputProps {
  picture: string | undefined;
  disabled: boolean;
}

export function PictureInput({
  picture,
  disabled,
}: Readonly<PictureInputProps>): ReactElement {
  const { setValue } = useFormContext<EditClientFormValues>();
  const inputFileReference = useRef<HTMLInputElement>(null);
  const [preview, setPreview] = useState<string | undefined>(picture);

  function onClickButton(): void {
    inputFileReference.current?.click();
  }

  async function onFileChange(event: ChangeEvent<HTMLInputElement>): Promise<void> {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setValue('picture', reader.result as string);
        setPreview(reader.result as string);
      };
      reader.readAsDataURL(file);
    }
  }

  function onDeletePicture(): void {
    setPreview(undefined);
    setValue('picture', '');
  }

  useEffect(() => {
    if (picture) {
      setPreview(picture);
    }
  }, [picture]);

  return (
    <PictureInputContainer>
      <span>Logo</span>
      {preview ? (
        <PictureBox>
          <Image
            width="185px"
            height="76px"
            src={String(preview)}
            preview={{
              getContainer: getContainerModal('edit-client-modal'),
            }}
          />
          <DeleteButton
            type="button"
            onClick={onDeletePicture}
            disabled={disabled}
          >
            <FaRegTrashAlt color="#ED193F" />
          </DeleteButton>
        </PictureBox>
      ) : (
        <PictureButton
          onClick={onClickButton}
          type="button"
          disabled={disabled}
        >
          <span color="#555555">Selecionar imagem</span>
          <FaFileUpload color="#555555" />
        </PictureButton>
      )}
      <input
        id="file-input"
        type="file"
        name="client-logo"
        accept="image/*"
        ref={inputFileReference}
        onChange={onFileChange}
        hidden
      />
    </PictureInputContainer>
  );
}
